export default __webpack_public_path__ + "static/media/profile.92f51b72.svg";